import { useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { Heading, Page, PropertyCard } from '@zillow/constellation-10';
import { GetApplicationsForUserDocument } from '../graphql/queries';
import { ApplicationsList } from '../components/ApplicationsList';
import { useUnifiedAppsTreatment } from '../utils/ab-tests';
import { EXTERNAL_URLS } from '../constants/urls';

export default function ApplicationsPage() {
  const treatment = useUnifiedAppsTreatment();
  const isUnifiedAppsPending = treatment !== 'off';

  useEffect(() => {
    if (treatment === 'on') {
      window.location.replace(`${EXTERNAL_URLS.ORCHESTRATOR}${window.location.search}`);
    }
  }, [treatment]);

  const { loading, data } = useQuery(GetApplicationsForUserDocument, {
    variables: {
      includeSharedApplications: true,
    },
    skip: isUnifiedAppsPending,
  });

  const isLoading = isUnifiedAppsPending || loading;

  return (
    <Page.Root css={{ backgroundColor: 'backgroundWhite', minHeight: '100vh' }}>
      <Page.Header>
        <Heading level={1}>Your rental applications</Heading>
      </Page.Header>
      <Page.Content>
        {data && <ApplicationsList data={data} />}
        {isLoading && !data && <ApplicationsLoading />}
      </Page.Content>
    </Page.Root>
  );
}

function ApplicationsLoading() {
  return (
    <>
      <PropertyCard appearance="horizontal" data={{}} loading css={{ maxWidth: '100%', marginBottom: 'default' }} />
      <PropertyCard appearance="horizontal" data={{}} loading css={{ maxWidth: '100%', marginBottom: 'default' }} />
      <PropertyCard appearance="horizontal" data={{}} loading css={{ maxWidth: '100%', marginBottom: 'default' }} />
    </>
  );
}
